/**
 * "What's new" bookkeeping, kept apart from the dialog so the header can reopen
 * it without loading it.
 *
 * The key carries the release: a later upgrade sets a new RELEASE and everyone
 * sees its notes once.
 */

export const RELEASE = 'v2-2026-10';
export const SEEN_KEY = 'callvibe.whatsNew.seen';
export const OPEN_EVENT = 'callvibe:whats-new';

export const openWhatsNew = () => window.dispatchEvent(new Event(OPEN_EVENT));

export const readSeen = () => {
  try {
    return window.localStorage.getItem(SEEN_KEY) === RELEASE;
  } catch {
    return false; // storage blocked: show it, the user can still close it
  }
};

export const markSeen = () => {
  try {
    window.localStorage.setItem(SEEN_KEY, RELEASE);
  } catch {
    /* storage blocked: nothing to remember it in */
  }
};
